<template>
  <!-- You have to add v-scroll-spy="{offset: -500}" every page where you use it -->
  <div
    class="landing-page"
    v-if="$root.dataReady"
    v-scroll-spy="{ offset: -500 }"
  >
    <header class="heading">
      <div class="container">
        <div class="text">
          <h1
            class="aos-init aos-animate"
            data-aos="fade-up"
            data-aos-delay="500"
            v-text="page.title.rendered"
          ></h1>
          <h2
            class="aos-init aos-animate"
            data-aos="fade-up"
            data-aos-delay="500"
            v-text="page.acf.subtitle"
          ></h2>
        </div>
        <StickyNavigation :navigationLinks="blocks"></StickyNavigation>
      </div>
      <div
        class="bg"
        :class="page.acf.hero_picture_position"
        v-if="page.better_featured_image"
        :style="{
          'background-image':
            'url( ' + page.better_featured_image.source_url + ' )',
        }"
      ></div>
    </header>

    <template>
      <template v-for="(block, index) in blocks">
        <!-- :id="`link-${index}`"  - that name is important and is used in StickyNavigation component -->
        <component
          :id="`link-${index}`"
          :is="block.acf_fc_layout"
          :key="index"
          :blockdata="block"
        ></component>
      </template>
    </template>
  </div>
</template>

<script>
import StickyNavigation from "../components/StickyNavigation";
import Block from "../components/Block.vue";
import AwardsSlider from "../components/AwardsSlider.vue";
import VideoWrapper from "../components/VideoWrapper";

export default {
  name: "landing-page",
  data() {
    return {
      blocks: null,
      page: null,
    };
  },
  components: {
    StickyNavigation,
    Block,
    VideoWrapper,
    AwardsSlider,
  },
  created: function () {
    this.$root.dataReady = false;
    this.$root.headeriswhite = true;
  },
  mounted: function () {
    this.fetchData();
  },
  props: ["slug"],
  methods: {
    fetchData: function () {
      var self = this;
      $.get(
        self.$root.apiUrl +
          "wp-json/wp/v2/landing_page?slug=" +
          self.$route.params.name,
        function (response) {
          self.blocks = response[0].acf.landing_page;
          self.page = response[0];
          self.setTitle(response[0].title.rendered);
          self.$root.dataReady = true;
        }
      )
        .done(function () {})
        .fail(function () {});
    },
    setTitle: function (title) {
      title = title.normalize("NFD").replace("&#038;", "&");
      document.title = title + " - Weber Shandwick";
    },
  },
};
</script>



// WEBPACK FOOTER //
// LandingPage.vue?f7de62a2